module.exports = __webpack_public_path__ + "media/images/import-enrichment-520d7f64364b03cf1d77ccf9d1210c2d.svg";